<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader , FormWizard, TabContent, Multiselect},
    data() {
        return {
            title: "Digitalizar encuesta",
            items: [
                {
                text: "Digitalizar",
                href: "/"
                },
                {
                text: "Digitar encuesta",
                active: true
                }
            ],
            isLoading: false,
            imagenes:[],
            datos:{
                rut:'',
                fecha:'',
                dia_nacimiento:'',
                mes_nacimiento:'',
                anio_nacimiento:'',
                nombres:'',
                apellido_paterno:'',
                apellido_materno:'',
                nombre_colegio:'',
                rbd_colegio:'',
                curso:'',
                celular:'',
                email:'',
                carrera:null,
                sede:null,
                // Digitalizador 2.0: comuna del establecimiento (campo del propio formulario v2).
                comuna_establecimiento: '',
                es_pasaporte: false
            },
            rotacionFrontal: 0, // Nueva propiedad para la rotación
            rotacionAtras: 0, // Nueva propiedad para la rotación
            colegioseleccionada: null,
            datoscolegios: [],
            currentStep: 1,
            sedes: [
                'Santiago Centro',
                'La Florida',
                'Maipú',
                'Melipilla',
                'Providencia',
                'Concepción',
                'Viña del Mar'
            ],
            carreras: [
                { codigo: 'USC1318', nombre: 'Administración Pública', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UME153', nombre: 'Agronomía', sede: 'Melipilla', comuna: 'Santiago' },
                { codigo: 'UPR153', nombre: 'Agronomía', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UPR1103', nombre: 'Animación Digital', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UPR160', nombre: 'Arquitectura', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC174', nombre: 'Comunicación Audiovisual y Multimedia', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UPR161', nombre: 'Construcción Civil', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC159', nombre: 'Contador Auditor', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO156', nombre: 'Derecho', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR156', nombre: 'Derecho', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC156', nombre: 'Derecho', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL156', nombre: 'Derecho', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1644', nombre: 'Diseño', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UCO166', nombre: 'Educación Parvularia', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'USC166', nombre: 'Educación Parvularia', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO1157', nombre: 'Enfermería', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF1157', nombre: 'Enfermería', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UMP1157', nombre: 'Enfermería', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR1157', nombre: 'Enfermería', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC1157', nombre: 'Enfermería', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL1157', nombre: 'Enfermería', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1203', nombre: 'Fonoaudiología', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR1203', nombre: 'Fonoaudiología', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1203', nombre: 'Fonoaudiología', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1623', nombre: 'Gastronomía y Negocios Gastronómicos', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC1593', nombre: 'Ingeniería Civil en Ciencia de Datos e Inteligencia Artificial', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO154', nombre: 'Ingeniería Civil Industrial', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'USC154', nombre: 'Ingeniería Civil Industrial', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC1651', nombre: 'Ingeniería Civil Informática', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC1594', nombre: 'Ingeniería Civil Química', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UPR1652', nombre: 'Ingeniería Comercial', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UCO1652', nombre: 'Ingeniería Comercial', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF1652', nombre: 'Ingeniería Comercial', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UVL1652', nombre: 'Ingeniería Comercial', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1112', nombre: 'Kinesiología', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF1112', nombre: 'Kinesiología', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UMP1112', nombre: 'Kinesiología', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR1112', nombre: 'Kinesiología', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC1112', nombre: 'Kinesiología', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL1112', nombre: 'Kinesiología', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'USC1294', nombre: 'Licenciatura en Ciencias de la Actividad Física', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO163', nombre: 'Medicina Veterinaria', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF163', nombre: 'Medicina Veterinaria', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UME163', nombre: 'Medicina Veterinaria', sede: 'Melipilla', comuna: 'Santiago' },
                { codigo: 'UMP163', nombre: 'Medicina Veterinaria', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR163', nombre: 'Medicina Veterinaria', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC163', nombre: 'Medicina Veterinaria', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL163', nombre: 'Medicina Veterinaria', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UPR1132', nombre: 'Nutrición y Dietética', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1132', nombre: 'Nutrición y Dietética', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1132', nombre: 'Nutrición y Dietética', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'USC1132', nombre: 'Nutrición y Dietética', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UPR1422', nombre: 'Obstetricia y Puericultura', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1422', nombre: 'Obstetricia y Puericultura', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'USC167', nombre: 'Pedagogía en Educación Básica', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC1149', nombre: 'Pedagogía en Educación Diferencial', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC168', nombre: 'Pedagogía en Educación Física', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'USC165', nombre: 'Periodismo', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO158', nombre: 'Psicología', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'ULF158', nombre: 'Psicología', sede: 'La Florida', comuna: 'Santiago' },
                { codigo: 'UMP158', nombre: 'Psicología', sede: 'Maipú', comuna: 'Santiago' },
                { codigo: 'UPR158', nombre: 'Psicología', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'USC158', nombre: 'Psicología', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UVL158', nombre: 'Psicología', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'UCO1204', nombre: 'Terapia Ocupacional', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR1204', nombre: 'Terapia Ocupacional', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1204', nombre: 'Terapia Ocupacional', sede: 'Viña del Mar', comuna: 'Viña del Mar' },
                { codigo: 'USC1135', nombre: 'Trabajo Social', sede: 'Santiago Centro', comuna: 'Santiago' },
                { codigo: 'UCO1695', nombre: 'Traducción Inglés - Español', sede: 'Concepción', comuna: 'Concepción' },
                { codigo: 'UPR1695', nombre: 'Traducción Inglés - Español', sede: 'Providencia', comuna: 'Santiago' },
                { codigo: 'UVL1695', nombre: 'Traducción Inglés - Español', sede: 'Viña del Mar', comuna: 'Viña del Mar' }
            ],
            carrerasFiltradas: [],
            // Digitalizador 2.0: multi-selección sede+carrera (máximo maxPreferencias).
            // Cada item: { sede: string|null, carrera: {codigo,nombre,sede,comuna}|null }
            preferencias: [{ sede: null, carrera: null }],
            preferenciasOrigen: '',
            maxPreferencias: 3,
            ruterror:'',
            searchTimeout: null,
            colegioQuery: '',
            cropTop: 100, // px a ocultar desde arriba
            cargandoContextoEvento: false,
            eventoInfo: null,
            colegioInfo: null,
            tiposCatalogo: [],
            subtiposCatalogo: [],
        };
    },
    props: {
        evento_id: {
            type: [String, Number],
            required: false
        },
        laborante_id: {
            type: [String, Number],
            required: false
        }
    },
    computed: {
        esV2() {
            return Number(this.imagenes?.[0]?.formulario_version) === 2;
        },
        esV3() {
            return Number(this.imagenes?.[0]?.formulario_version) === 3;
        },
        usaPreferenciasMultiples() {
            return [2, 3].includes(Number(this.imagenes?.[0]?.formulario_version));
        },
        admitePasaporte() {
            return [2, 3].includes(Number(this.imagenes?.[0]?.formulario_version));
        },
        // Comunas estandarizadas para el select v2 (mismo catálogo que las sedes UDLA).
        comunasEstandarizadas() {
            return [
                { value: '', text: '-- Seleccionar comuna estándar --' },
                'La Florida',
                'Maipú',
                'Melipilla',
                'Providencia',
                'Santiago Centro',
                'Concepción',
                'Viña del Mar'
            ];
        }
    },
    watch: {
        'datos.sede'(nuevaSede) {
            if (!nuevaSede) {
                this.carrerasFiltradas = [];
                this.datos.carrera = null; // limpiar selección anterior
                return;
            }
            this.carrerasFiltradas = this.carreras.filter(c => c.sede == nuevaSede);
            this.datos.carrera = null; // reiniciar la carrera seleccionada
            this.$nextTick(() => {
                if (this.$refs.msCarrera) {
                    this.$refs.msCarrera.activate(); // Abre el dropdown automáticamente
                }
            });
        },
        'datos.es_pasaporte'() {
            this.ruterror = '';
            this.formatRut();
            this.validateRut();
        }
    },
    mounted() {
        this.cargarCatalogosTipoSubtipo();
        this.cargarContextoEvento();
        this.cargarImagenesSinRevisar();
        console.log(this.imagenes[1]?.url_publica);
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.datoscolegios = response.data.colegios;
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
        // Esperamos un pequeño delay para que el multiselect exista en el DOM
        this.$nextTick(() => {
            if (this.$refs.msSede) {
                this.$refs.msSede.activate(); // Abre el dropdown automáticamente
            }
        });
    },
    methods:{
        async cargarCatalogosTipoSubtipo() {
            try {
                const response = await axios.get('/api/get_tipos');
                this.tiposCatalogo = Array.isArray(response?.data?.tipos) ? response.data.tipos : [];
                this.subtiposCatalogo = Array.isArray(response?.data?.subtipos) ? response.data.subtipos : [];
            } catch (error) {
                this.tiposCatalogo = [];
                this.subtiposCatalogo = [];
            }
        },
        async cargarContextoEvento() {
            if (!this.evento_id) {
                return;
            }

            this.cargandoContextoEvento = true;
            try {
                const response = await axios.get('/api/get_eventos');
                const eventos = Array.isArray(response?.data?.eventos) ? response.data.eventos : [];
                const eventoEncontrado = eventos.find((evento) => Number(evento?.id) === Number(this.evento_id));

                if (!eventoEncontrado) {
                    this.eventoInfo = null;
                    this.colegioInfo = null;
                    return;
                }

                this.eventoInfo = eventoEncontrado;

                const rbd = String(eventoEncontrado?.rbd_colegio || '').trim();
                if (!rbd) {
                    this.colegioInfo = null;
                    return;
                }

                const colegioResponse = await axios.get(`/api/get_colegio/${encodeURIComponent(rbd)}`);
                this.colegioInfo = colegioResponse?.data?.estado ? (colegioResponse?.data?.colegio || null) : null;
            } catch (error) {
                this.eventoInfo = null;
                this.colegioInfo = null;
            } finally {
                this.cargandoContextoEvento = false;
            }
        },
        textoInfo(value, fallback = '-') {
            const texto = String(value ?? '').trim();
            return texto !== '' ? texto : fallback;
        },
        buscarNombreCatalogo(catalogo, valor) {
            const objetivo = String(valor ?? '').trim();
            if (!objetivo) return '';

            const item = (Array.isArray(catalogo) ? catalogo : []).find((row) => {
                const codigo = String(row?.codigo ?? '').trim();
                const id = String(row?.id ?? '').trim();
                return codigo === objetivo || id === objetivo;
            });

            return String(item?.nombre ?? '').trim();
        },
        nombreTipoEvento() {
            const directo = String(this.eventoInfo?.tipo_nombre ?? '').trim();
            if (directo) return directo;

            const porCatalogo = this.buscarNombreCatalogo(
                this.tiposCatalogo,
                this.eventoInfo?.tipo ?? this.eventoInfo?.tipo_codigo
            );

            return porCatalogo || this.eventoInfo?.tipo;
        },
        nombreSubtipoEvento() {
            const directo = String(this.eventoInfo?.subtipo_nombre ?? '').trim();
            if (directo) return directo;

            const porCatalogo = this.buscarNombreCatalogo(
                this.subtiposCatalogo,
                this.eventoInfo?.subtipo ?? this.eventoInfo?.subtipo_codigo
            );

            return porCatalogo || this.eventoInfo?.subtipo;
        },
        formatearFechaEvento(value) {
            const raw = String(value ?? '').trim();
            if (!raw) return '-';

            const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
            if (match) {
                const [, year, month, day, hour = '00', minute = '00'] = match;
                return `${day}/${month}/${year} ${hour}:${minute}`;
            }

            const date = new Date(raw);
            if (Number.isNaN(date.getTime())) return raw;

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hour}:${minute}`;
        },
        numeroInfo(value) {
            const numero = Number(value);
            return Number.isFinite(numero) ? numero : 0;
        },
        esPdfFicha(imagen) {
            const url = imagen?.url_publica;
            if (!url) return false;
            if (Number(imagen?.formulario_version) === 2) return true;
            return /\.pdf(\?|$)/i.test(String(url));
        },
        normalizeCurso(curso) {
            const valor = String(curso ?? '').trim();

            if (!valor || valor === "''") {
                return '';
            }

            if (['1', '2', '3', '4'].includes(valor)) {
                return valor;
            }

            return valor.toLowerCase() === 'egresado' ? 'Egresado' : '';
        },
        isFrontImage(imagen) {
            return ['Pendiente', 'ActualizadoAWS', 'Revisada'].includes(imagen?.tipo_mime);
        },
        isBackImage(imagen) {
            return ['Trasera', 'TraseraRevisada'].includes(imagen?.tipo_mime);
        },
        extractFirstValidPair(sourceList) {
            const list = Array.isArray(sourceList) ? sourceList : [];

            for (let i = 0; i < list.length; i++) {
                const front = list[i];
                if (!this.isFrontImage(front)) {
                    continue;
                }

                // V2 y V3: ficha única, no tienen trasera.
                if ([2, 3].includes(Number(front?.formulario_version))) {
                    return [front];
                }

                // Priorizar pareja explícita si existe.
                if (front?.imagen_trasera_id) {
                    const explicitBack = list.find((item) => item?.id === front.imagen_trasera_id && this.isBackImage(item));
                    if (explicitBack) {
                        return [front, explicitBack];
                    }
                }

                // Si no hay referencia explícita, buscar la primera trasera antes del siguiente frontal.
                for (let j = i + 1; j < list.length; j++) {
                    const candidate = list[j];
                    if (this.isFrontImage(candidate)) {
                        break;
                    }
                    if (this.isBackImage(candidate)) {
                        return [front, candidate];
                    }
                }

                // Fallback legado: en algunas cargas antiguas ambas páginas quedaron como
                // ActualizadoAWS pendiente (sin marcar trasera). En ese caso emparejar por
                // consecutividad (orden o id) para no bloquear la digitalización.
                if (front?.tipo_mime === 'ActualizadoAWS') {
                    const frontOrden = Number(front?.orden || 0);
                    const frontId = Number(front?.id || 0);

                    const legacyPair = list.find((candidate) => {
                        if (!candidate || Number(candidate?.id || 0) === frontId) return false;
                        if (candidate?.tipo_mime !== 'ActualizadoAWS') return false;
                        if ((candidate?.estado_revision || 'pendiente') !== (front?.estado_revision || 'pendiente')) return false;

                        const candidateOrden = Number(candidate?.orden || 0);
                        const candidateId = Number(candidate?.id || 0);

                        return candidateOrden === (frontOrden + 1) || candidateId === (frontId + 1);
                    });

                    if (legacyPair) {
                        return [front, legacyPair];
                    }
                }
            }

            return [];
        },
        applyCurrentPair(sourceList) {
            const pair = this.extractFirstValidPair(sourceList);
            this.imagenes = pair;

            const esFichaIndividual = [2, 3].includes(Number(pair[0]?.formulario_version));
            // V1 requiere par; V2 y V3 contienen una ficha por registro.
            if (pair.length === 0 || (!esFichaIndividual && pair.length < 2)) {
                return false;
            }

            const img0 = pair[0];
            let persistedData = img0?.data || {};
            if (typeof persistedData === 'string') {
                try {
                    persistedData = JSON.parse(persistedData);
                } catch (_) {
                    persistedData = {};
                }
            }
            this.datos.es_pasaporte = this.admitePasaporte
                && [true, 1, '1', 'true'].includes(persistedData?.es_pasaporte);
            this.datos.rut = img0?.rut || '';
            this.datos.fecha = (img0?.fecha || '').replace(/\s+/g, '').toUpperCase();
            const partes = this.datos.fecha.split('-');
            this.datos.dia_nacimiento = partes[0] || '';
            this.datos.mes_nacimiento = partes[1] || '';
            this.datos.anio_nacimiento = partes[2] || '';
            const nombreCompletoOriginal = this.isNombreOcrValido(img0?.nombre_completo || img0?.nombres)
                ? (img0?.nombre_completo || img0?.nombres || '').toUpperCase()
                : '';
            const nombresOriginales = this.isNombreOcrValido(img0?.nombres)
                ? (img0?.nombres || '').toUpperCase()
                : '';
            let nombresSeparados = nombresOriginales;
            let apellidoPaternoSeparado = this.isNombreOcrValido(img0?.apellido_paterno)
                ? (img0?.apellido_paterno || '').toUpperCase()
                : '';
            let apellidoMaternoSeparado = this.isNombreOcrValido(img0?.apellido_materno)
                ? (img0?.apellido_materno || '').toUpperCase()
                : '';

            if (nombreCompletoOriginal && (!apellidoPaternoSeparado || !apellidoMaternoSeparado || nombresOriginales === nombreCompletoOriginal)) {
                const nombreSeparado = this.splitNombreCompleto(nombreCompletoOriginal);
                nombresSeparados = nombreSeparado.nombres || nombresSeparados;
                apellidoPaternoSeparado = apellidoPaternoSeparado || nombreSeparado.apellido_paterno;
                apellidoMaternoSeparado = apellidoMaternoSeparado || nombreSeparado.apellido_materno;
            }

            this.datos.nombres = nombresSeparados;
            this.datos.apellido_paterno = apellidoPaternoSeparado;
            this.datos.apellido_materno = apellidoMaternoSeparado;
            this.datos.nombre_colegio = (img0?.establecimiento || '').toUpperCase();
            this.datos.rbd_colegio = img0?.rbd_colegio || '';
            // Digitalizador 2.0: comuna del establecimiento (vínea del propio formulario).
            this.datos.comuna_establecimiento = (img0?.comuna_establecimiento || '').toString();
            this.datos.curso = this.normalizeCurso(img0?.curso);
            this.datos.celular = (img0?.celular || '').replace(/\s+/g, '').toUpperCase();
            this.datos.email = (img0?.email || '').replace(/\s+/g, '').toUpperCase();
            this.datos.carrera = null;
            this.datos.sede = null;
            // V2 y V3 permiten registrar varias preferencias sede+carrera.
            this.restaurarPreferencias(img0);
            this.colegioseleccionada = null;

            return true;
        },
        isNombreOcrValido(valor) {
            const texto = String(valor || '').replace(/\s+/g, ' ').trim().toUpperCase();

            if (!texto || texto.length < 2 || /[@0-9]/.test(texto)) {
                return false;
            }

            const palabras = texto.match(/[A-ZÁÉÍÓÚÑ]+/g) || [];
            const etiquetas = new Set([
                'NOMBRE', 'NOMBRES', 'APELLIDO', 'APELLIDOS', 'PATERNO', 'MATERNO',
                'RUT', 'PASAPORTE', 'DNI', 'DOCUMENTO', 'NUMERO', 'NÚMERO', 'NUM', 'N',
                'FECHA', 'NACIMIENTO', 'COLEGIO', 'ESTABLECIMIENTO', 'CURSO', 'NIVEL',
                'TELEFONO', 'TELÉFONO', 'CELULAR', 'CORREO', 'EMAIL', 'FIRMA', 'AUTORIZACION', 'AUTORIZACIÓN',
                'DE', 'DEL', 'LA', 'LAS', 'LOS', 'Y', 'O', 'SI', 'SÍ', 'NO',
            ]);
            const significativas = palabras.filter(palabra => !etiquetas.has(palabra));

            return significativas.length > 0;
        },
        splitNombreCompleto(nombreCompleto) {
            const limpio = String(nombreCompleto || '').replace(/\s+/g, ' ').trim().toUpperCase();
            const partes = limpio ? limpio.split(' ').filter(Boolean) : [];

            const conectoresSimple = new Set(['DE', 'DEL', 'LA', 'LAS', 'LOS', 'DA', 'DAS', 'DO', 'DOS', 'DI', 'VAN', 'VON', 'MC', 'MAC', 'SAN', 'SANTA']);
            const conectoresDobles = new Set(['DE LA', 'DE LAS', 'DE LOS']);

            const extraerApellidoDesdeFinal = (tokens) => {
                if (!tokens.length) {
                    return { apellido: '', inicio: 0 };
                }

                const apellido = [tokens[tokens.length - 1]];
                let i = tokens.length - 2;

                while (i >= 0) {
                    if (i >= 1) {
                        const doble = `${tokens[i - 1]} ${tokens[i]}`;
                        if (conectoresDobles.has(doble)) {
                            apellido.unshift(tokens[i - 1], tokens[i]);
                            i -= 2;
                            continue;
                        }
                    }

                    if (conectoresSimple.has(tokens[i])) {
                        apellido.unshift(tokens[i]);
                        i -= 1;
                        continue;
                    }

                    break;
                }

                return {
                    apellido: apellido.join(' ').trim(),
                    inicio: i + 1,
                };
            };

            if (partes.length === 1) {
                return {
                    nombres: partes[0] || '',
                    apellido_paterno: '',
                    apellido_materno: '',
                };
            }

            if (partes.length === 2) {
                return {
                    nombres: partes[0] || '',
                    apellido_paterno: partes[1] || '',
                    apellido_materno: '',
                };
            }

            if (partes.length >= 3) {
                const maternalInfo = extraerApellidoDesdeFinal(partes);
                const antesMaterno = partes.slice(0, maternalInfo.inicio);

                if (antesMaterno.length <= 1) {
                    return {
                        nombres: antesMaterno[0] || '',
                        apellido_paterno: maternalInfo.apellido,
                        apellido_materno: '',
                    };
                }

                const paternalInfo = extraerApellidoDesdeFinal(antesMaterno);
                const nombres = antesMaterno.slice(0, paternalInfo.inicio).join(' ').trim();

                return {
                    nombres,
                    apellido_paterno: paternalInfo.apellido,
                    apellido_materno: maternalInfo.apellido,
                };
            }

            return {
                nombres: limpio,
                apellido_paterno: '',
                apellido_materno: '',
            };
        },
        // Digitalizador 2.0: helpers para la multi-selección sede+carrera.
        carrerasParaSede(sede) {
            return sede ? this.carreras.filter(c => c.sede === sede) : [];
        },
        normalizarTextoCatalogo(valor) {
            return String(valor || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-z0-9]+/gi, ' ')
                .trim()
                .toLowerCase();
        },
        obtenerDataImagen(imagen) {
            if (imagen?.data && typeof imagen.data === 'object') {
                return imagen.data;
            }

            if (typeof imagen?.data === 'string') {
                try {
                    return JSON.parse(imagen.data) || {};
                } catch (error) {
                    return {};
                }
            }

            return {};
        },
        restaurarPreferencias(imagen) {
            const data = this.obtenerDataImagen(imagen);
            const guardadas = Array.isArray(data.preferencias) ? data.preferencias : [];
            const sugeridas = Array.isArray(data.preferencias_sugeridas)
                ? data.preferencias_sugeridas
                : (Array.isArray(imagen?.preferencias_sugeridas) ? imagen.preferencias_sugeridas : []);
            const origen = guardadas.length ? 'guardado' : (sugeridas.length ? 'ocr' : '');
            const candidatas = guardadas.length ? guardadas : sugeridas;
            const restauradas = [];

            candidatas.slice(0, this.maxPreferencias).forEach((preferencia) => {
                if (origen === 'ocr' && String(preferencia?.confidence || '').toLowerCase() !== 'high') {
                    return;
                }

                const sede = preferencia?.sede || preferencia?.campus || '';
                const codigo = preferencia?.carrera_codigo || '';
                const nombre = preferencia?.carrera_nombre || preferencia?.carrera || preferencia?.career || '';
                const carrera = this.carreras.find((item) => (
                    item.sede === sede
                    && (item.codigo === codigo || this.normalizarTextoCatalogo(item.nombre) === this.normalizarTextoCatalogo(nombre))
                ));

                if (carrera && !restauradas.some((item) => item.carrera.codigo === carrera.codigo)) {
                    restauradas.push({ sede: carrera.sede, carrera });
                }
            });

            this.preferencias = restauradas.length ? restauradas : [{ sede: null, carrera: null }];
            this.preferenciasOrigen = restauradas.length ? origen : '';
        },
        agregarPreferencia() {
            if (this.preferencias.length < this.maxPreferencias) {
                this.preferencias.push({ sede: null, carrera: null });
            }
        },
        quitarPreferencia(idx) {
            if (this.preferencias.length > 1) {
                this.preferencias.splice(idx, 1);
            } else {
                // Si sólo queda 1, limpiarla en vez de quitarla.
                this.preferencias.splice(0, 1, { sede: null, carrera: null });
            }
        },
        onSedePreferenciaChange(idx) {
            // Al cambiar la sede de un par, limpiar la carrera correspondiente.
            if (this.preferencias[idx]) {
                this.$set(this.preferencias[idx], 'carrera', null);
            }
        },
        construirPreferenciasLimpias() {
            return (this.preferencias || [])
                .filter(p => p && p.sede && p.carrera && p.carrera.codigo)
                .map(p => ({
                    sede: p.sede,
                    carrera_codigo: p.carrera.codigo,
                    carrera_nombre: p.carrera.nombre,
                    comuna: p.carrera.comuna || '',
                }));
        },
        buildBasePayload() {
            const rut = this.datos.es_pasaporte
                ? this.normalizePassport(this.datos.rut)
                : (this.datos.rut || '').trim();
            const nombres = (this.datos.nombres || '').trim();
            const apellidoPaterno = (this.datos.apellido_paterno || '').trim();
            const apellidoMaterno = (this.datos.apellido_materno || '').trim();
            const dia = this.esV3 ? '' : (this.datos.dia_nacimiento || '').trim();
            const mes = this.esV3 ? '' : (this.datos.mes_nacimiento || '').trim();
            const anio = this.esV3 ? '' : (this.datos.anio_nacimiento || '').trim();
            const fecha = [dia, mes, anio].some(value => value) ? `${dia}-${mes}-${anio}` : '';

            return {
                rut,
                es_pasaporte: this.admitePasaporte && this.datos.es_pasaporte,
                fecha,
                dia_nacimiento: dia,
                mes_nacimiento: mes,
                anio_nacimiento: anio,
                nombre_completo: [nombres, apellidoPaterno, apellidoMaterno].filter(Boolean).join(' '),
                nombres,
                apellido_paterno: apellidoPaterno,
                apellido_materno: apellidoMaterno,
                nombre_colegio: (this.datos.nombre_colegio || '').trim(),
                curso: this.normalizeCurso(this.datos.curso),
                celular: (this.datos.celular || '').replace(/\s+/g, ''),
                email: (this.datos.email || '').replace(/\s+/g, ''),
                carrera: this.usaPreferenciasMultiples
                    ? (this.construirPreferenciasLimpias()[0]?.carrera_codigo || '')
                    : (this.datos.carrera?.codigo || ''),
                preferencias: this.usaPreferenciasMultiples ? this.construirPreferenciasLimpias() : [],
                evento_id: this.evento_id,
                rbd_colegio: this.colegioseleccionada?.rbd || this.datos.rbd_colegio || '',
                // Digitalizador 2.0: comuna del establecimiento (sólo v2; en v1 va string vacío).
                comuna_establecimiento: this.esV2 ? (this.datos.comuna_establecimiento || '').trim() : '',
                laborante_id: this.laborante_id,
                id_imagen: this.imagenes[0]?.id || null,
                id_imagen2: this.imagenes[1]?.id || null,
            };
        },
        async guardarBorrador() {
            const datosEnviar = this.buildBasePayload();

            if (!datosEnviar.id_imagen) {
                this.$bvToast.toast('No se encontró una imagen para guardar.', {
                    title: 'Borrador no guardado',
                    variant: 'warning',
                    solid: true
                });
                return;
            }

            this.isLoading = true;

            try {
                const response = await axios.post('/api/guardar_borrador_imagen', datosEnviar);
                const imagen = response.data?.imagen || null;

                if (imagen && this.imagenes[0]?.id === imagen.id) {
                    this.imagenes.splice(0, 1, imagen);
                }

                this.$bvToast.toast(response.data?.message || 'Borrador guardado correctamente.', {
                    title: 'Borrador guardado',
                    variant: 'success',
                    solid: true
                });
            } catch (error) {
                console.error(error);
                const mensaje = error.response?.data?.message || 'No se pudo guardar el borrador.';
                this.$bvToast.toast(mensaje, {
                    title: 'Error al guardar',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        },
        normalizeAndValidatePhone(phoneInput) {
            const raw = String(phoneInput || '').replace(/\s+/g, '');
            if (!raw) {
                return { value: '', reason: '' };
            }

            // Solo permitimos digitos y '+' al inicio.
            if (!/^\+?[0-9]+$/.test(raw)) {
                return {
                    value: '',
                    reason: 'no tiene formato valido (debe ser +569XXXXXXXX, sin letras ni simbolos adicionales)',
                };
            }

            let normalized = raw;
            if (normalized.startsWith('+')) {
                normalized = normalized.substring(1);
            }

            // Formatos de entrada aceptados: 9XXXXXXXX, 569XXXXXXXX, +569XXXXXXXX.
            if (/^9\d{8}$/.test(normalized)) {
                return { value: `+56${normalized}`, reason: '' };
            }

            if (/^569\d{8}$/.test(normalized)) {
                return { value: `+${normalized}`, reason: '' };
            }

            return {
                value: '',
                reason: 'no tiene formato valido (debe ser +569XXXXXXXX: +569 y 8 digitos)',
            };
        },
        normalizeAndValidateEmail(emailInput) {
            const raw = String(emailInput || '').replace(/\s+/g, '').toLowerCase();
            if (!raw) {
                return { value: '', reason: '' };
            }

            const basicRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
            if (!basicRegex.test(raw) || raw.includes('..')) {
                return { value: '', reason: 'no tiene formato valido' };
            }

            const parts = raw.split('@');
            if (parts.length !== 2) {
                return { value: '', reason: 'no tiene formato valido' };
            }

            const domain = parts[1];
            const suspiciousDomains = [
                'gamail.com',
                'gamali.com',
                'gmial.com',
                'gmai.com',
                'gmaill.com',
                'hotnail.com',
                'outlok.com',
                'yaho.com',
                'gmail.clo',
            ];
            if (suspiciousDomains.includes(domain)) {
                return { value: '', reason: 'parece tener un dominio confuso o mal escrito' };
            }

            const tld = domain.split('.').pop() || '';
            const allowedTlds = ['com', 'cl', 'org', 'net', 'edu', 'gov', 'mil', 'io'];
            if (!allowedTlds.includes(tld)) {
                return { value: '', reason: `termina en .${tld}, que no es un dominio esperado` };
            }

            return { value: raw, reason: '' };
        },
        async onComplete() {
            if (this.datos.es_pasaporte) {
                const pasaporte = this.normalizePassport(this.datos.rut);
                if (!pasaporte) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Pasaporte inválido',
                        text: 'El pasaporte debe contener letras o números.'
                    });
                    return;
                }
                this.datos.rut = pasaporte;
            }

            // --- Validaciones antes de enviar ---
            const datosBase = this.buildBasePayload();
            const rut = datosBase.rut;
            const nombres = datosBase.nombres;
            const apellidoPaterno = datosBase.apellido_paterno;
            const tieneMinimoCRM = rut && nombres && apellidoPaterno;
            // Teléfono: normalizar a +569XXXXXXXX | solo válido si tiene 8 dígitos después del 9
            const celularRaw = (this.datos.celular || '').replace(/\s+/g, '');
            const celularValidation = this.normalizeAndValidatePhone(celularRaw);
            const celularFinal = celularValidation.value;

            // Email: formato básico válido
            const emailRaw = (this.datos.email || '').replace(/\s+/g, '').toLowerCase();
            const emailValidation = this.normalizeAndValidateEmail(emailRaw);
            const emailFinal = emailValidation.value;

            // Fecha de nacimiento: día 1-31, mes 1-12, año 1980-2015
            let diaFinal = this.esV3 ? '' : (this.datos.dia_nacimiento || '').trim();
            let mesFinal = this.esV3 ? '' : (this.datos.mes_nacimiento || '').trim();
            let anioFinal = this.esV3 ? '' : (this.datos.anio_nacimiento || '').trim();
            // Validar siempre si hay valores (incluso sin tieneMinimoCRM)
            if (diaFinal && mesFinal && anioFinal) {
                const d = parseInt(diaFinal), m = parseInt(mesFinal), a = parseInt(anioFinal);
                const fechaValida = d >= 1 && d <= 31 && m >= 1 && m <= 12 && a >= 1980 && a <= 2015;
                if (!fechaValida) { diaFinal = ''; mesFinal = ''; anioFinal = ''; }
            }
            const fechaFinal = (diaFinal && mesFinal && anioFinal)
                ? `${diaFinal}-${mesFinal}-${anioFinal}`
                : '';

            // Avisar al digitalizador qué campos se corrigieron
            const advertencias = [];
            if (celularRaw && !celularFinal) {
                advertencias.push(`<li><b>Teléfono</b> "<i>${celularRaw}</i>" ${celularValidation.reason} → se envía vacío.</li>`);
            }
            if (emailRaw && !emailFinal) {
                advertencias.push(`<li><b>Email</b> "<i>${emailRaw}</i>" ${emailValidation.reason} → se envía vacío.</li>`);
            }
            const fechaOriginal = this.esV3
                ? []
                : [this.datos.dia_nacimiento, this.datos.mes_nacimiento, this.datos.anio_nacimiento].map(v => (v||'').trim());
            if (fechaOriginal.some(v => v) && !fechaFinal) {
                advertencias.push(`<li><b>Fecha de nacimiento</b> "${fechaOriginal.join('-')}" no es válida (debe estar entre 1980-2015) → se envía vacía.</li>`);
            }
            if (!celularFinal && !emailFinal) {
                advertencias.push('<li><b>Contacto</b>: no quedo celular ni email validos. <b>Se sugiere descartar esta ficha</b> si no es posible corregir un medio de contacto.</li>');
            }

            if (advertencias.length > 0) {
                const continuar = await Swal.fire({
                    icon: 'warning',
                    title: 'Datos con formato incorrecto',
                    html: `<p>Se detectaron campos que serán descartados o normalizados:</p><ul style="text-align:left;margin:0.5em 0 0 1em;">${advertencias.join('')}</ul><p style="margin-top:0.8em;">¿Deseas continuar o volver a corregirlos?</p>`,
                    showCancelButton: true,
                    confirmButtonText: 'Continuar igual',
                    cancelButtonText: 'Volver a editar',
                    confirmButtonColor: '#f0ad4e',
                });
                if (!continuar.isConfirmed) return;
            }
            // --- Fin validaciones ---

            const datosEnviar = {
                ...datosBase,
                rut: rut,
                fecha: fechaFinal,
                dia_nacimiento: diaFinal,
                mes_nacimiento: mesFinal,
                anio_nacimiento: anioFinal,
                nombres: nombres,
                apellido_paterno: apellidoPaterno,
                apellido_materno: datosBase.apellido_materno,
                nombre_completo: [nombres, apellidoPaterno, datosBase.apellido_materno].filter(Boolean).join(' '),
                nombre_colegio: datosBase.nombre_colegio,
                curso: datosBase.curso,
                celular: celularFinal,
                email: emailFinal,
            };

            const esFichaIndividual = [2, 3].includes(Number(this.imagenes[0]?.formulario_version));
            if (!datosEnviar.id_imagen || (!esFichaIndividual && !datosEnviar.id_imagen2)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Ficha incompleta',
                    text: esFichaIndividual
                        ? 'No se encontró la ficha a enviar.'
                        : 'No se encontró un par válido (frontal + trasera) para enviar. Puedes descartar y pasar a la siguiente.'
                });
                return;
            }

            this.isLoading = true;
            axios.post('/api/actualizar_imagen_revisada', datosEnviar)
                .then(response => {
                    const data = response.data || {};

                    // Si el backend indica error (por ejemplo campos faltantes en CRM)
                    if (!data.estado) {
                        const mensaje = data.mensaje || 'Error';
                        let errores = [];
                        if (mensaje.includes('- El atributo')) {
                            errores = mensaje
                                .split('- El atributo')
                                .slice(1)
                                .map(e => e.trim().replace(/\[|\]/g, ''))
                                .filter(Boolean);
                        }
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al guardar la revisión',
                            html: errores.length
                                ? `<div style="font-weight:bold;color:#d9534f;">Faltan datos:</div>
                                <ul style="margin-left:1em;color:#333;">${errores.map(e => `<li>${e}</li>`).join('')}</ul>`
                                : mensaje,
                            confirmButtonText: 'Cerrar'
                        });
                        return;
                    }

                    // Éxito: actualizar lista de imágenes y poblar datos (si hay)
                    const lista = data.imagenes || [];
                    console.log(`Imagenes por revisar: ${lista.length}`);
                    if (!this.applyCurrentPair(lista)) {
                        this.$bvToast.toast('No hay más imágenes para revisar, redireccionando...', {
                            title: 'Información',
                            variant: 'info',
                            solid: true
                        });
                        setTimeout(() => {
                            window.location.href = '/web/digitalizar/asociar';
                        }, 3000);
                        return;
                    }

                    this.$bvToast.toast('Revisión guardada y siguiente ficha cargada correctamente', {
                        title: 'Revisión guardada',
                        variant: 'success',
                        solid: true
                    });
                    this.$refs.formWizard.reset();
                })
                .catch(error => {
                    console.error(error);
                    if (error.response && error.response.status === 413) {
                        Swal.fire('Error', 'Archivo demasiado grande para el servidor (413).');
                    } else {
                        const mensaje = error.response?.data?.message || 'Error al guardar la revisión';
                        this.$bvToast.toast(mensaje, {
                            title: 'Error de revisión',
                            variant: 'danger',
                            solid: true
                        });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        cargarImagenesSinRevisar() {
            this.isLoading = true;
            axios.get('/api/imagenes_digitalizadas', {
                params: {
                    evento_id: this.evento_id,
                    laborante_id: this.laborante_id,
                    estado: 'sin_revisar'
                }
            })
            .then(response => {
                const lista = response.data.imagenes || [];
                console.log(`Imagenes por revisar: ${lista.length}`);
                this.isLoading = false;
                if(!this.applyCurrentPair(lista)) {
                    this.$bvToast.toast('No hay más imágenes para revisar, redireccionando...', {
                        title: 'Información',
                        variant: 'info',
                        solid: true
                    });
                    // redireccionar a /web/digitalizar/asociar despues de 3 seg
                    setTimeout(() => {
                        window.location.href = '/web/digitalizar/asociar';
                    }, 3000);
                }
                console.log('cargarImagenesSinRevisar');
                console.log(this.datos);
                this.isLoading = false;

            })
            .catch(error => {
                console.error('Error al cargar imágenes:', error);
                this.isLoading = false;
            });
        },
        customLabel(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        fetchColegios(query) {
            // Limpiar timeout anterior
            clearTimeout(this.searchTimeout);

            // Si no hay query o es muy corta, no buscar
            if (!query || query.trim().length < 3) {
                return;
            }

            // Esperar 500ms después de que el usuario deje de escribir
            this.searchTimeout = setTimeout(() => {
                this.isLoading = true;
                axios.get(`/api/colegios?search=${query}`)
                    .then(response => {
                        this.datoscolegios = response.data;
                    })
                    .catch(error => console.error(error))
                    .finally(() => this.isLoading = false);
            }, 500);
        },
        handleStepChange(prevIndex, nextIndex) {
        this.currentStep = nextIndex + 1; // los pasos comienzan desde 0
        },
        carreraLabel(option) {
            if (!option) return '';
            return `${option.nombre} - ${option.sede}`;
        },
        formatRut() {
            if (this.datos.es_pasaporte) {
                this.datos.rut = this.normalizePassport(this.datos.rut);
                return;
            }

            // 1. Dejar solo números y k
            let cleanRut = this.datos.rut.replace(/[^0-9kK]/g, "").toUpperCase();

            // 2. Limitar largo máximo: 9 dígitos + dígito verificador (total 10)
            // Permite RUTs sobre 100 millones.
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10);
            }

            // 3. Si hay más de un carácter, separar cuerpo y DV
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1);
                const dv = cleanRut.slice(-1);

                // 4. Asignar sin puntos y con guion
                this.datos.rut = `${body}-${dv}`;
            } else {
                // Si es solo 1 carácter, se deja tal cual
                this.datos.rut = cleanRut;
            }
        },
        normalizePassport(value) {
            return String(value || '')
                .toUpperCase()
                .replace(/[^A-Z0-9-]+/g, '')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '');
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        normalizarRbd(rbd) {
            return rbd === null || rbd === undefined ? '' : String(rbd).trim();
        },
        onColegioSeleccionado(colegio) {
            if (!colegio) {
                this.datos.rbd_colegio = '';
                return;
            }

            this.datos.nombre_colegio = (colegio.nombre || '').toUpperCase();
            this.datos.rbd_colegio = this.normalizarRbd(colegio.rbd);
        },
        onNombreColegioInput(valor) {
            if (!this.colegioseleccionada) {
                return;
            }

            const nombreSeleccionado = (this.colegioseleccionada.nombre || '').toUpperCase().trim();
            const nombreIngresado = (valor || '').toUpperCase().trim();

            if (nombreIngresado !== nombreSeleccionado) {
                this.colegioseleccionada = null;
                this.datos.rbd_colegio = '';
            }
        },
        validateRut() {
            // Si es pasaporte, no validar
            if (this.datos.es_pasaporte) {
                this.ruterror = '';
                return;
            }

            let rut = this.cleanRut(this.datos.rut);
            if (!rut) {
                this.ruterror = 'RUT inválido';
                return;
            }

            let digito_verificador = this.datos.rut.slice(-1).toUpperCase();
            rut = rut.slice(0, rut.length - 1);

            let suma = 0;
            let multiplo = 2;

            for (let i = rut.length - 1; i >= 0; i--) {
                suma += parseInt(rut.charAt(i)) * multiplo;
                multiplo = multiplo < 7 ? multiplo + 1 : 2;
            }

            let dv_calculado = 11 - (suma % 11);
            if (dv_calculado === 11) dv_calculado = '0';
            else if (dv_calculado === 10) dv_calculado = 'K';
            else dv_calculado = dv_calculado.toString();

            if (digito_verificador !== dv_calculado) {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        antesdecambiar() {
            if (this.datos.es_pasaporte) {
                const pasaporte = this.normalizePassport(this.datos.rut);
                if (!pasaporte) {
                    this.$toasted.error("Debe ingresar pasaporte");
                    return false;
                }
                this.datos.rut = pasaporte;
                if (!String(this.datos.nombres || '').trim()) {
                    this.$toasted.error("El nombre no puede estar vacío");
                    return false;
                }
                if (!String(this.datos.apellido_paterno || '').trim()) {
                    this.$toasted.error("El apellido paterno no puede estar vacío");
                    return false;
                }
                return true;
            }

            // Asegura formato limpio (sin puntos/comas) y validación al presionar "Siguiente"
            // incluso si el input no perdió foco (sin blur).
            this.formatRut();
            this.validateRut();

            // 1. Validar error previo
            if (this.ruterror != '') {
                this.$toasted.error("El Rut no es válido");
                return false;
            }

            // 2. Validar que el RUT esté en formato sin puntos y con guion
            //    Ejemplo válido: 12345678-9, 11111111-K o 100000000-1
            const rutFormatoCorrecto = /^\d{1,9}-[\dkK]$/;
            if (!rutFormatoCorrecto.test(this.datos.rut)) {
                this.$toasted.error("El formato del RUT debe ser sin puntos y con guion (Ej: 11111111-1)");
                return false;
            }
            if (!String(this.datos.nombres || '').trim()) {
                this.$toasted.error("El nombre no puede estar vacío");
                return false;
            }
            if (!String(this.datos.apellido_paterno || '').trim()) {
                this.$toasted.error("El apellido paterno no puede estar vacío");
                return false;
            }
            // 3. Si todo está OK
            return true;
        },
        async cortar() {
            // Obtener el contenedor y la imagen actuales
            const contenedor = this.currentStep === 1 ? this.$refs.container1 : this.$refs.container2;
            const img = this.currentStep === 1 ? this.$refs.image1 : this.$refs.image2;

            if (!contenedor || !img) return;

            // Calcular el rectángulo visible de la imagen
            const rect = contenedor.getBoundingClientRect();
            const imgRect = img.getBoundingClientRect();

            // Calcular el centro del contenedor
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            // Calcular el centro de la imagen
            const imgCenterX = imgRect.left + imgRect.width / 2;
            const imgCenterY = imgRect.top + imgRect.height / 2;

            // Calcular el factor de escala (suponiendo que queremos un cuadrado de 300x300px)
            const scale = 300 / Math.min(rect.width, rect.height);

            // Calcular el nuevo tamaño de la imagen
            const newWidth = imgRect.width * scale;
            const newHeight = imgRect.height * scale;

            // Calcular la posición de la imagen recortada
            const cropX = centerX - imgCenterX;
            const cropY = centerY - imgCenterY;

            // Aplicar el recorte (usando CSS para simplificar)
            img.style.width = `${newWidth}px`;
            img.style.height = `${newHeight}px`;
            img.style.objectFit = 'cover';
            img.style.objectPosition = `${-cropX}px ${-cropY}px`;
        },

        // Descarta el par completo de imágenes (delantera + trasera) y carga el siguiente par
        async descartarYPasar() {
            // Siempre usamos la primera imagen (delantera) ya que el backend elimina el par completo
            const imagen = this.imagenes[0];
            if (!imagen || !imagen.id) {
                this.$bvToast.toast('No hay imágenes para descartar', { title: 'Error', variant: 'danger', solid: true });
                return;
            }

            const confirmar = await Swal.fire({
                title: 'Confirmar descartado',
                text: '¿Deseas descartar este par de imágenes (delantera + trasera) y pasar al siguiente?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, descartar',
                confirmButtonColor: "#C87838",
                cancelButtonText: 'Cancelar'
            });
            if (!confirmar.isConfirmed) return;

            this.isLoading = true;
            try {
                const payload = { id_imagen: imagen.id };
                const resp = await axios.post('/api/descartar_imagen', payload);

                // Si el backend devuelve lista actualizada de imágenes la usamos
                if (resp.data && resp.data.imagenes) {
                    const lista = resp.data.imagenes || [];

                    // Si no hay más imágenes, redirigir
                    if (!this.applyCurrentPair(lista)) {
                        this.$bvToast.toast('No hay más imágenes para revisar, redireccionando...', {
                            title: 'Información',
                            variant: 'info',
                            solid: true
                        });
                        setTimeout(() => {
                            window.location.href = '/web/digitalizar/asociar';
                        }, 3000);
                        return;
                    }

                }

                // Resetear formulario al primer paso
                if (this.$refs.formWizard && this.$refs.formWizard.reset) {
                    this.$refs.formWizard.reset();
                }
                this.currentStep = 1;

                this.$bvToast.toast('Par de imágenes descartado correctamente', {
                    title: 'Éxito',
                    variant: 'success',
                    solid: true
                });
            } catch (err) {
                console.error('Error descartando imagen:', err);
                this.$bvToast.toast('Error al descartar las imágenes', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        },
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row" v-if="cargandoContextoEvento || eventoInfo || colegioInfo">
            <div class="col-12 resumen-contexto-wrap">
                <div class="card mb-3 resumen-contexto-card" style="border-left: 4px solid #c87838;">
                    <div class="card-body resumen-contexto-body py-2">
                        <div v-if="cargandoContextoEvento" class="text-muted" style="font-size: 0.9rem;">
                            Cargando información del evento y colegio...
                        </div>
                        <div v-else class="row">
                            <div class="col-md-6 mb-2 mb-md-0">
                                <h6 class="mb-1 resumen-contexto-titulo">Evento</h6>
                                <div class="resumen-contexto-texto">
                                    <div><strong>Código:</strong> {{ textoInfo(eventoInfo?.codigo) }}</div>
                                    <div><strong>Nombre difusión:</strong> {{ textoInfo(eventoInfo?.nombre_difusion) }}</div>
                                    <div><strong>Tipo:</strong> {{ textoInfo(nombreTipoEvento()) }}</div>
                                    <div><strong>Subtipo:</strong> {{ textoInfo(nombreSubtipoEvento()) }}</div>
                                    <div><strong>Coordinador:</strong> {{ textoInfo(eventoInfo?.coordinador_evento) }}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h6 class="mb-1 resumen-contexto-titulo">Colegio asociado</h6>
                                <div class="resumen-contexto-texto">
                                    <div><strong>RBD:</strong> {{ textoInfo(eventoInfo?.rbd_colegio || colegioInfo?.rbd) }}</div>
                                    <div><strong>Nombre:</strong> {{ textoInfo(colegioInfo?.nombre || eventoInfo?.colegio) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <loading-message v-if="isLoading" />
            <div class="col-12">
                <div class="card mi-card pb-4 mb-4 shadow-lg" style="height: auto;">
                    <div class="card-body wizard-card-body text-center">
                        <div class="row">
                            <div class="col-md-6">
                                <div v-if="imagenes[0]!=''" v-show="currentStep === 1 || esPdfFicha(imagenes[0]) || esV3">
                                    <h5 v-if="esV3">{{ currentStep === 1 ? 'Datos del formulario:' : 'Selección de carreras:' }}</h5>
                                    <h5 v-else>{{ esPdfFicha(imagenes[0]) ? 'Documento PDF (Digitalizador 2.0):' : 'Imagen Frontal:' }}</h5>
                                    <div
                                        class="image-container1"
                                        :class="{ 'v3-page-crop': esV3, 'v3-page-crop--bottom': esV3 && currentStep === 2 }"
                                        ref="container1"
                                    >
                                        <iframe
                                            v-if="esPdfFicha(imagenes[0])"
                                            :src="imagenes[0]?.url_publica"
                                            style="width:100%; height:85vh; min-height:700px; border:0;"
                                        ></iframe>
                                        <img v-else ref="image1" :src="imagenes[0]?.url_publica" alt="Foto1" :style="{ transform: 'rotate(' + rotacionFrontal + 'deg)' }"/>
                                    </div>
                                </div>
                                <!-- Imagen Atrás: solo visible en paso 4 o al finalizar -->
                                <div v-if="imagenes[1] != '' && !esPdfFicha(imagenes[0])" v-show="currentStep === 2">
                                    <h5>Imagen Atrás:</h5>
                                    <div class="image-container2" ref="container2">
                                        <!-- <img ref="image2" :src="imagenes[1]?.url_publica" alt="Foto2" :style="{ transform: 'rotate(' + rotacionAtras + 'deg)' }"/> -->
                                        <img ref="image2" :src="imagenes[1]?.url_publica" alt="Foto2"
                                            :style="{ transform: 'translateY(-' + cropTop + 'px) rotate(' + rotacionAtras + 'deg)' }"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <b-button variant="outline-danger" class="mr-2" @click="descartarYPasar">
                                    <i class="bx bx-trash"></i> Descartar y siguiente
                                </b-button>
                                <b-button variant="outline-primary" class="mr-2" :disabled="isLoading" @click="guardarBorrador">
                                    Guardar
                                </b-button>
                                 <!-- <h5 class="text-secondary">Revisa los datos a continuación, si están correctos presiona "Siguiente", en caso contrario modificalos y luego presiona "Siguiente".</h5> -->
                                 <form-wizard
                                 color="#C87838"
                                 @on-complete="onComplete"
                                 @on-change="handleStepChange"
                                 title=""
                                 subtitle=""
                                 nextButtonText="Siguiente"
                                 backButtonText="Atrás"
                                 finishButtonText="Validar y enviar"
                                 ref="formWizard"
                                 >
                                    <tab-content title="Datos personales" :before-change="antesdecambiar">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Rut / Pasaporte:</label>
                                                    <b-form-input
                                                        v-model="datos.rut"
                                                        :class="ruterror && !datos.es_pasaporte ? 'input-error' : 'border-primary'"
                                                        @blur="validateRut"
                                                        @input="formatRut"
                                                    ></b-form-input>
                                                    <p v-if="!datos.es_pasaporte">Debe ser sin puntos y con guión</p>
                                                    <p v-else>Puede contener letras, números y guiones.</p>
                                                    <p v-if="ruterror && !datos.es_pasaporte" class="error text-danger">{{ ruterror }}</p>
                                                    <b-form-checkbox
                                                        v-if="admitePasaporte"
                                                        v-model="datos.es_pasaporte"
                                                        class="mt-2"
                                                    >
                                                        Documento extranjero (Pasaporte)
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-6 d-flex justify-content-center" v-if="!esV2 && !esV3">
                                                <div class="form-group text-center">
                                                    <label for="fecha">Fecha de Nacimiento:</label>
                                                    <div class="d-flex justify-content-center ">
                                                        <b-form-input
                                                            v-model="datos.dia_nacimiento"
                                                            class="border-primary text-center "
                                                            placeholder="DD"
                                                            maxlength="2"
                                                            style="width: 70px;"
                                                        ></b-form-input>
                                                        <b-form-input
                                                            v-model="datos.mes_nacimiento"
                                                            class="border-primary text-center "
                                                            placeholder="MM"
                                                            maxlength="2"
                                                            style="width: 70px;"
                                                        ></b-form-input>
                                                        <b-form-input
                                                            v-model="datos.anio_nacimiento"
                                                            class="border-primary text-center"
                                                            placeholder="AAAA"
                                                            maxlength="4"
                                                            style="width: 90px;"
                                                        ></b-form-input>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Nombres:</label>
                                                    <b-form-input v-model="datos.nombres" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Apellido Paterno:</label>
                                                    <b-form-input v-model="datos.apellido_paterno" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Apellido Materno:</label>
                                                    <b-form-input v-model="datos.apellido_materno" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> Celular:</label>
                                                    <b-form-input v-model="datos.celular" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="pais"> E-mail:</label>
                                                    <b-form-input v-model="datos.email" class="border-primary"></b-form-input>
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                    <label for="pais"> Nombre del Establecimiento Educacional:</label>
                                                    <b-form-input
                                                        v-model="datos.nombre_colegio"
                                                        class="border-primary mb-2"
                                                        @input="onNombreColegioInput"
                                                    ></b-form-input>
                                                    <multiselect
                                                        v-model="colegioseleccionada"
                                                        :options="datoscolegios"
                                                        :searchable="true"
                                                        :loading="isLoading"
                                                        :custom-label="customLabel"
                                                        placeholder="Buscar colegio..."
                                                        @search-change="fetchColegios"
                                                        @input="onColegioSeleccionado"
                                                        selectLabel="Presiona para seleccionar"
                                                        selectedLabel="Seleccionado"
                                                        deselectLabel="Presiona para remover"
                                                    >
                                                        <template v-slot:noOptions>
                                                            <p>No hay opciones</p>
                                                        </template>
                                                        <template v-slot:noResult>
                                                            <p>No se encuentra coincidencia</p>
                                                        </template>
                                                    </multiselect>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="curso">Curso:</label>
                                                    <b-form-radio-group
                                                        v-model="datos.curso"
                                                        class="d-flex flex-column align-items-start border border-primary rounded p-2"
                                                        name="curso"
                                                    >
                                                        <b-form-radio value="1">1ro medio</b-form-radio>
                                                        <b-form-radio value="2">2do medio</b-form-radio>
                                                        <b-form-radio value="3">3ro medio</b-form-radio>
                                                        <b-form-radio value="4">4to medio</b-form-radio>
                                                        <b-form-radio value="Egresado">Egresado</b-form-radio>
                                                        <b-form-radio :value="''">En blanco</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                            </div>
                                        </div>
                                    </tab-content>
                                    <tab-content title="Confirmación">
                                        <div class="row">
                                            <!-- Digitalizador 1.0: un solo par sede + carrera -->
                                            <template v-if="!usaPreferenciasMultiples">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="pais"> Campus:</label>
                                                        <multiselect
                                                            ref="msSede"
                                                            v-model="datos.sede"
                                                            :options="sedes"
                                                            :searchable="true"
                                                            selectLabel="Presiona para seleccionar"
                                                            selectedLabel="Seleccionado"
                                                            deselectLabel="Presiona para remover"
                                                            placeholder="Selecciona campus"
                                                        >
                                                            <template v-slot:noOptions>
                                                                <p>No hay opciones</p>
                                                            </template>
                                                            <template v-slot:noResult>
                                                                <p>No se encuentra coincidencia</p>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="pais"> Carrera:</label>
                                                        <multiselect
                                                            ref="msCarrera"
                                                            v-model="datos.carrera"
                                                            :options="carrerasFiltradas"
                                                            :disabled="!datos.sede"
                                                            :searchable="true"
                                                            selectLabel="Presiona para seleccionar"
                                                            selectedLabel="Seleccionado"
                                                            deselectLabel="Presiona para remover"
                                                            placeholder="Selecciona carrera"
                                                            :custom-label="carreraLabel"
                                                        >
                                                            <template v-slot:noOptions>
                                                                <p>No hay opciones</p>
                                                            </template>
                                                            <template v-slot:noResult>
                                                                <p>No se encuentra coincidencia</p>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </template>

                                            <!-- Digitalizador 2.0 y V3: hasta maxPreferencias pares sede+carrera -->
                                            <template v-else>
                                                <div class="col-md-12 mb-2">
                                                    <small class="text-muted">
                                                        Preferencias del postulante (hasta {{ maxPreferencias }}). El primer par es el que se envía al CRM.
                                                    </small>
                                                    <div v-if="preferenciasOrigen === 'ocr'" class="alert alert-info py-2 mt-2 mb-1">
                                                        Se precargaron marcas detectadas por OCR. Confirma cada campus y carrera antes de finalizar.
                                                    </div>
                                                </div>
                                                <div
                                                    v-for="(pref, idx) in preferencias"
                                                    :key="'pref-' + idx"
                                                    class="col-md-12"
                                                >
                                                    <div class="row align-items-end">
                                                        <div class="col-md-5">
                                                            <div class="form-group">
                                                                <label>Campus #{{ idx + 1 }}:</label>
                                                                <multiselect
                                                                    v-model="pref.sede"
                                                                    :options="sedes"
                                                                    :searchable="true"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    placeholder="Selecciona campus"
                                                                    @input="onSedePreferenciaChange(idx)"
                                                                >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Carrera #{{ idx + 1 }}:</label>
                                                                <multiselect
                                                                    v-model="pref.carrera"
                                                                    :options="carrerasParaSede(pref.sede)"
                                                                    :disabled="!pref.sede"
                                                                    :searchable="true"
                                                                    selectLabel="Presiona para seleccionar"
                                                                    selectedLabel="Seleccionado"
                                                                    deselectLabel="Presiona para remover"
                                                                    placeholder="Selecciona carrera"
                                                                    :custom-label="carreraLabel"
                                                                >
                                                                    <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                    <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                                                </multiselect>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-1 form-group">
                                                            <b-button
                                                                v-if="preferencias.length > 1"
                                                                variant="outline-danger"
                                                                size="sm"
                                                                @click="quitarPreferencia(idx)"
                                                                title="Quitar"
                                                            >
                                                                <i class="mdi mdi-close"></i>
                                                            </b-button>
                                                            <b-button
                                                                v-else
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                @click="quitarPreferencia(idx)"
                                                                title="Limpiar"
                                                            >
                                                                <i class="mdi mdi-eraser"></i>
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 mb-3">
                                                    <b-button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        :disabled="preferencias.length >= maxPreferencias"
                                                        @click="agregarPreferencia"
                                                    >
                                                        <i class="mdi mdi-plus"></i>
                                                        Añadir preferencia
                                                        <span v-if="preferencias.length >= maxPreferencias" class="text-muted">
                                                            (máximo {{ maxPreferencias }})
                                                        </span>
                                                    </b-button>
                                                </div>
                                            </template>
                                            <div class="col-md-12">
                                                <div class="text-center">
                                                    <h2 class="mt-0">
                                                        <i class="mdi mdi-check-all text-success"></i>
                                                    </h2>
                                                    <h3 class="mt-0">¡Gracias por completar la información!</h3>
                                                </div>
                                                <div class="pt-4 pb-4 px-2 bg-light">
                                                    <div class="">
                                                        <div class="row mt-3">
                                                            <div class="offset-md-1 col-md-5">
                                                                <p><b>Rut/Pasaporte: {{ this.datos.rut }}</b></p>
                                                                <p><b>Nombre Completo: {{ this.datos.nombres }} {{ this.datos.apellido_paterno }} {{ this.datos.apellido_materno }}</b></p>
                                                                <p><b>Curso: {{ this.datos.curso }}</b></p>
                                                                <p><b>E-mail: {{ this.datos.email }}</b></p>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <p v-if="!esV3"><b>Fecha de Nacimiento: {{ this.datos.dia_nacimiento }}-{{ this.datos.mes_nacimiento }}-{{ this.datos.anio_nacimiento }}</b></p>
                                                                <p><b>Colegio: {{ colegioseleccionada ? ((colegioseleccionada.rbd || '') + '-' + (colegioseleccionada.nombre || '')) : '' }}</b></p>
                                                                <p><b>Celular: {{ this.datos.celular }}</b></p>
                                                                <p><b>Carrera: {{ this.datos.sede }} - {{ this.datos.carrera?datos.carrera.nombre:'' }}</b></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="text-primary">*Si la información está correcta presiona "Guardar revisión y siguiente"</p>
                                            </div>
                                        </div>
                                    </tab-content>
                                </form-wizard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<style scoped>
.wizard-card-body {
  position: relative;
  min-height: 700px; /* mantiene altura base del wizard */
  max-height: 700px; /* evita que crezca más en el último paso */
  overflow-y: auto;  /* scroll interno si el contenido excede */
  overflow-x: visible;
  padding-bottom: 2rem;
}

.resumen-contexto-card {
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    margin-bottom: 0.75rem !important;
}

.resumen-contexto-wrap {
    display: block;
}

.resumen-contexto-body {
    min-height: auto !important;
    max-height: none !important;
    height: auto !important;
    overflow: visible !important;
    padding: 0.6rem 0.9rem !important;
}

.resumen-contexto-texto {
    font-size: 0.78rem;
    line-height: 1.25;
}

.resumen-contexto-titulo {
    color: #c87838;
    font-weight: 700;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .resumen-contexto-card {
        width: 100%;
        display: block;
    }

    .resumen-contexto-body {
        padding: 0.55rem 0.75rem !important;
    }

    .resumen-contexto-texto {
        font-size: 0.76rem;
    }
}

/* asegura que el dropdown se vea completo */
.multiselect__content-wrapper {
  max-height: 300px !important;
  overflow-y: auto !important;
  z-index: 9999 !important;
}

/* evita que el wizard estire el contenedor */
.vue-form-wizard {
  height: 100%;
}

/* permite que los dropdowns no se corten */
.multiselect {
  position: relative;
  z-index: 10;
}

/* estiliza el tab de confirmación para que no tenga tanto espacio */
.tab-content:last-child .card.bg-light {
  max-width: 800px;
  margin: 0 auto;
}
.input-error {
  border: 2px solid #dc3545 !important; /* rojo Bootstrap */
  border-radius: 0.25rem; /* opcional, mantener estilo Bootstrap */
}
.image-container1,
.image-container2 {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden;
}

.image-container1 img,
.image-container2 img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
}

.v3-page-crop {
    aspect-ratio: 4 / 3;
    height: auto;
    max-height: 72vh;
    background: #f4f5f7;
}

.v3-page-crop img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    max-width: none;
}

.v3-page-crop--bottom img {
    top: auto;
    bottom: 0;
    left: 10%;
    width: 80%;
}

/* Lupa */
.lens1,
.lens2 {
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    pointer-events: none;
    background-repeat: no-repeat;
    background-size: 200% 200%; /* IMPORTANTE para el zoom */
    border: 2px solid #00000055;
    display: none;
}
.mi-card {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
}
</style>
